import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './Pages/LandingPage'
import Navbar from './Components/NavBar'
import Footer from './Components/Footer'
import AboutUsPage from './Pages/AboutUsPage'
import ContactUs from './Components/ContactUs'

const App = () => {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/contact" element={<ContactUs />} />


      </Routes>
      <Footer/>
    </Router>
  )
}

export default App